import React from 'react';
import './Services.css'
import useServices from '../../../../../Hooks/useServices';
import Service from '../../Service/Service';

const Services = () => {
  const [services] = useServices();
  return (
   <div className="services_page">
      <div className='container services_area mt-5'>
   <div className="row">
   {services.map(service => <Service key={service.id} service={service} />)}
   </div>
 </div>
   </div>
  );
};

export default Services;